import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { ZfBox } from '@zafire/react';
import type { PropsWithChildren } from 'react';
import type { DomicileDto } from '../../../api/generated/client';
import type { IDndItem } from '../../../interfaces/dnd';

interface IProps<TItem> extends PropsWithChildren {
    item: TItem;
}

export const Draggable = <TItem extends DomicileDto | IDndItem>({ item, children }: IProps<TItem>) => {
    const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id: item.id.toString() });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.5 : 1,
    };

    return (
        <ZfBox ref={setNodeRef} {...attributes} {...listeners} style={style} className={`dnd-item ${isDragging ? 'dnd-item-dragging-origin' : ''}`}>
            {children}
        </ZfBox>
    );
};
